module.exports = __webpack_public_path__ + "img/001-pdf.acd43187.svg";